
import { useState, useEffect, useRef } from "react";
import { useApi } from "../../hooks/useApi";

const Manual = ({ className }) => {
  const baseName = import.meta.env.VITE_APP_BASE_URL;
  const mainSiteUrl = import.meta.env.VITE_MAIN_SITE_URL;
  const time = Date.now();
  const initialized = useRef(false);
  const { apiCall } = useApi();
  const [manualLink, setManualLink] = useState(null);
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      apiCall(`get_setting`, { params: { setting: 'manual_link' } }) // Update with your actual API endpoint
        .then(response => response.json())
        .then((data) => {
          setManualLink(data.value);
        });
    }
  });
  return (
    <a href={`${manualLink}?v=${time}`} target="_blank" className={`manual-image text-center ${className}`}>
      <img src={`${baseName}manual.png`} alt="Manual" className="w-[35px] mx-auto" />
      <span>Manual</span>
    </a>
  );
};

export default Manual;
